// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RetentionPeriodType {
    Monthly = 0,
    Daily = 1
}
